<template>
  <div>
    <div>
      <div class="tabs-head">
        <router-link :to="'/my-gates/' + currentId + '/analytics'">
          <div class="tabs-head__item activeTab">
            <p>Analytics</p>
          </div>
        </router-link>
        <router-link :to="'/my-gates/' + currentId + '/settings'">
          <div class="tabs-head__item">
            <p>Settings</p>
          </div>
        </router-link>
      </div>
      <div class="statistics">
        <div class="d-flex w-100" v-if="preloadingCharts">
          <div style="width: 25%; min-width: 400px; border: 1px solid green">
            <PieChart />
          </div>
          <div style="width: 75%;border: 1px solid green;">
            <LineChart :labels="['25','26','27','28','29','30','31']" />
          </div>
        </div>
        <div class="statistics-box" style="border: 2px solid red;">
          <div class="statistics-box__field">
            <div class="left">
              <div class="top">
                <h2>Dashboard</h2>
                <div class="drop">
                  <div class="drop-wrap">
                    <p>Period</p>
                    <CustomDropdownBorder  :options="stat_periods"
                                           :period="false"
                                           :days="true"
                                           :withDatePicker="true"
                                           :selected="datePeriod"
                                           v-on:updateOption="changePeriod_v3"
                                           :placeholder="'Select an Item'"
                                           :closeOnOutsideClick="false"/>
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="legend">
                  <div class="legend-line tooltip-block">
                    <div class="legend-line-img failure">

                    </div>
                    <div class="legend-line-text">
                      <p>Failure</p>
                    </div>
                    <div class="tooltip tp-failure">
                      Users who visited but didn’t finish the gate
                    </div>
                  </div>
                  <div class="legend-line tooltip-block">
                    <div class="legend-line-img success">

                    </div>
                    <div class="legend-line-text">
                      <p>Success</p>
                    </div>
                    <div class="tooltip tp-success">
                      Users who successfully finished the gate
                    </div>
                  </div>
                </div>
                <div class="total" v-if="flag">
                  <p>Total visits: {{stat[0] + stat[1]}}</p>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="top"></div>
            </div>
          </div>
          <Preloader :showPreloader="!flag"/>
        </div>
        <Navigate @render="updateTable"/>
      </div>
    </div>
  </div>
</template>

<script>
import newChart from "./newChart";
import linChart from "./linChart";
import Datepicker from "@/components/Datepicker/Datepicker.vue";
import Navigate from "@/components/Navigate/Navigate.vue";
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import UpdateSettings from "@/views/UpdateSettings/UpdateSettings.vue";
import generalChart from "./generalChart";
import moment from 'moment';
import Preloader from "../../components/Preloader/Preloader.vue";
import api_requests from "../../store/api/api_requests";
import NoData from "@/components/__new_ui_kit/Table/NoData";
import LineChart from "@/views/StatisticsPage/charts/LineChart";
import PieChart from "@/views/StatisticsPage/charts/Doughnut";
import {mapGetters} from "vuex";

export default {
  name: "StatisticsPage",
  components: {
    PieChart,
    LineChart,
    newChart, linChart, CustomDropdownBorder, Datepicker, Navigate, UpdateSettings, generalChart, Preloader, NoData
  },
  data() {
    return {
      preloadingCharts: false,
      currentId: this.$route.params.id,
      doughnutIsEmpty: false,
      generalChartIsEmpty: false,
      days: [],
      vals: [],
      succcessGeneral: [],
      flag: true,
      activePage: 1,
      labels: [["Success"],["Failure"]],
      stat: false,
      statisticItem: [
        {id: 1, name: 'Success'},
        {id: 2, name: 'Visits'}
      ],
      //dropdown with periods for "Line Chart Statistic"
      periods: [
        {id: 1, name: '1 months'},
        {id: 2, name: '2 months'},
        {id: 3, name: '6 months'},
      ],
      stat_periods: [
        // {id: 1, name: 1},
        // {id: 2, name: 2},
        // {id: 3, name: 6},
        {id: 1, name: 'Today', pluck: 'today'},
        {id: 2, name: 'Yesterday', pluck: 'yesterday'},
        {id: 3, name: 'Last 7 Days', pluck: 'last_7_days'},
        {id: 4, name: 'This Month', pluck: 'this_month'},
        {id: 5, name: 'Last Month', pluck: 'last_month'},
      ],
      dateToLineChart: [],
      // datePeriod: {id: 1, name: 1},
      datePeriod: {id: 5, name: 'Last Month'},
      typeVisit: {id: 1, name: 'Visits'},
      allDate: [],
      tabAnalytics: '',
      vis: '',
      dateToLineChartVisits: [],
      dateToLineChartSuccess: []
    }
  },
  props: {
    propTabAnalytics: String
  },
  computed: {
    ...mapGetters(['getWidth']),
    width() {
      return this.getWidth
    }
  },
  watch: {
    width (v) {
      this.preloadingCharts = false
      setTimeout(() => {
        this.preloadingCharts = true
      }, 500)
      console.log(v)
    }
  },
  created() {
    this.onCreated();
    setTimeout(() => {
      this.preloadingCharts = true
    }, 500)
  },
  methods: {
    onCreated() {
      this.getDate()
          .then(() => {
            this.loadingStatistics()
                .then(res => {
                  this.allDay = res
                  this.change(this.allDay)
                })
            this.tabAnalytics = this.$props.propTabAnalytics === 'true'
          })
    },
    updateTable() {
      this.onCreated();
    },
    moment: function () {
      return moment();
    },
    checkEmptyChart(args) {
      const {type, isEmpty} = args
      if (type === 'doughnut') {
        this.doughnutIsEmpty = isEmpty
      }
      else {
        this.generalChartIsEmpty = isEmpty
      }
    },
    statistic_v3(period) {
      return new Promise((resolve) => {
        api_requests.get_statistics_v3({id: this.$route.params.id, period: period})
            .then((response) => {
              let list = response.data.data
              this.vals = response.data.failure_vals
              this.succcessGeneral = response.data.success_vals
              let stats = []
              let list_num = []
              list.map((item) => {
                list_num.push(Number(item[0] + '.' + String(item[1])))
              })
              this.days = list_num
              this.stat = [response.data.diagram_success_vals, response.data.diagram_failures_vals]
              resolve()
            })
      })
    },
    getDate(period) {
      return new Promise((resolve) => {
        api_requests.get_statistics({id: this.$route.params.id, period: period})
            .then((response) => {
              let list = response.data.data
              this.vals = response.data.failure_vals
              this.succcessGeneral = response.data.success_vals
              let stats = []
              let list_num = []
              list.map((item) => {
                list_num.push(Number(item[0] + '.' + String(item[1])))
              })
              this.days = list_num
              this.stat = [response.data.diagram_success_vals, response.data.diagram_failures_vals]
              resolve()
            })
      })
    },
    switchingTabs(name) {
      this.tabAnalytics = Boolean(name === 'analytics')
    },
    methodToRunOnSelect(payload) {
      this.selectedOption = payload;
      this.department = payload;
    },
    change() {
      this.flag = !this.flag;
      this.dateToLineChart = this.convertDateToLineChart(this.allDay, this.datePeriod.id, this.typeVisit.id)
      this.dateToLineChartVisits = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 1)
      this.dateToLineChartSuccess = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 2)
      setTimeout(() => this.flag = !this.flag, 0);
    },
    changeType(payload) {
      this.typeVisit = payload
      this.flag = !this.flag;
      this.dateToLineChart = this.convertDateToLineChart(this.allDay, this.datePeriod.id, this.typeVisit.id)
      this.dateToLineChartVisits = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 1)
      this.dateToLineChartSuccess = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 2)
      setTimeout(() => this.flag = !this.flag, 0);

    },
    changePeriod(payload) {
      this.datePeriod = payload
      this.flag = !this.flag;
      this.dateToLineChart = this.convertDateToLineChart(this.allDay, this.datePeriod.id, this.typeVisit.id)
      this.dateToLineChartVisits = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 1)
      this.dateToLineChartSuccess = this.convertDateToLineChart(this.allDay, this.datePeriod.id, 2)
      setTimeout(() => this.flag = !this.flag, 0);
    },
    // changePeriod_v2(payload, period) {
    //   this.flag = !this.flag;
    //   this.datePeriod = payload
    //   this.getDate(this.datePeriod.name).then(()=>{
    //     setTimeout(()=>{this.flag = !this.flag},0)
    //   })
    //
    // },
    changePeriod_v3(payload, period) {
      this.flag = !this.flag;
      this.datePeriod = payload
      this.statistic_v3(this.datePeriod.pluck).then(()=>{
        setTimeout(()=>{this.flag = !this.flag}, 0)
      })
    },
    getLastDayOfMonth(year, month) {
      let date = new Date(year, month + 1, 0);
      return date.getDate();
    },
    async loadingStatistics() {
      return new Promise((resolve, reject) => {
        const id = this.$route.params.id
        this.$store.dispatch('contentById', {id, full: true, non_edit: true})
            .then(resp => {
                  if (resp.status === 200) {
                    const visits = resp.data.visits
                    this.vis = visits
                    let countSuccess = 0
                    let allDate = []
                    visits.map(visit => {
                      let date = new Date(visit.created_at)
                      if (visit.result) {
                        countSuccess++
                      }
                      allDate.push({date, success: visit.result ?? false})
                    })
                    resolve(allDate)
                    // this.stat = [visits.length - countSuccess, countSuccess]
                  }
                  if (resp.status === 404) {
                    this.$router.push('/not-found');
                  }
                }
            )
      })

    },

    dateHelper(date) {
      const Day = date.getDate()
      const Mounth = date.getMonth()
      const Year = date.getFullYear()
      return `${Mounth + 1}/${Day}/${Year}`

    },

    periodHelper(period) {
      if (period === 1) {
        return 1
      }
      if (period === 2) {
        return 2
      }
      if (period === 3) {
        return 6
      }
      return 1
    },
    convertDateToLineChart(allDate, period, type) {
      const newDate = allDate

      const now = new Date()
      const nowDay = now.getDate()
      const nowMounth = now.getMonth()
      const nowYear = now.getFullYear()


      let datesArrayVisit = []

      let toMounth = this.periodHelper(period)
      for (let mounth = 0; mounth < toMounth; mounth++) {
        let lastDayMounth = this.getLastDayOfMonth(nowMounth - mounth, nowYear)
        for (let i = 1; i <= lastDayMounth; i++) {
          /*let m = nowMounth + 1 - mounth;
          let d = i
          let y = nowYear
          let format = `${m}/${d}/${y}`*/
          // console.log('format',format)
          // toMounth instead magic-const 1
          let dateString = Date.parse(`${nowMounth + toMounth - mounth}/${i}/${nowYear}`)
          /*console.log('dateString: ', dateString)
          console.log('nowMounth: ', nowMounth)
          console.log('mounth: ', mounth)
          console.log('i:', i)
          console.log('nowYear: ', nowYear)
          console.log('==================')*/
          if (!isNaN(dateString)) {
            datesArrayVisit.push({date: new Date(dateString), data: 0})
          }
        }
      }

      datesArrayVisit.sort(function (a, b) {
        var dateA = new Date(a.date), dateB = new Date(b.date)
        return dateA - dateB //сортировка по возрастающей дате
      })
      datesArrayVisit.forEach((day, idx) => {
        allDate.forEach(item => {
          if (this.dateHelper(day.date) === this.dateHelper(item.date)) {
            if (type === 1) {
              datesArrayVisit[idx].data++
            }
            if (type === 2) {
              if (item.success) {
                datesArrayVisit[idx].data++
              }
            }
          }

        })
      })

      datesArrayVisit.map((day, idx) => {
        datesArrayVisit[idx] = {date: day.date.getDate(), data: day.data}
      })
      return datesArrayVisit
    }
  }
};
</script>

<style scoped lang="sass">
.chart-wrapper
  position: relative
  &::v-deep .table-no-data
    max-width: 150px
    position: absolute
    border-bottom: none
    left: 0
    top: 0
    right: 0
    bottom: 0
    margin: auto
.tabs-head
  border-bottom: 1px solid #BDBDBD
  display: flex
  flex-direction: row
  justify-content: flex-start
  padding: 30px 0 0 0
  &__item
    width: 100px
    height: 40px
    display: flex
    align-items: center
    justify-content: center
    margin: 0 10px -1px 0
    border: 1px solid #BDBDBD
    border-radius: 5px 5px 0 0
    cursor: pointer
    p
      color: #777777
      font-weight: 400
  .activeTab
    border-bottom: 1px solid #fff
    p
      color: #454545

.statistics
  display: flex
  flex-direction: column
  align-items: flex-start
  justify-content: space-around
  padding: 40px 0 0 0
  &-box
    display: flex
    align-items: flex-start
    justify-content: space-around
    flex-direction: column
    width: 100%
    min-height: 530px
    position: relative
    .preloader-wrap
      position: absolute
      top: 0
      left: 0
      padding: 0
    &__field
      display: flex
      width: 100%
      .left
        width: 400px
        display: flex
        align-items: flex-start
        flex-direction: column
        justify-content: flex-start
        .top
          //height: 60px
          margin: 0 0 20px 0
          display: flex
          flex-direction: column
          align-items: flex-start
          justify-content: flex-start
          .drop
            display: flex
            align-items: flex-start
          h2
            font-family: 'Montserrat', sans-serif
            font-weight: 400
            font-size: 1.5em
        .box
          width: 360px
          height: 360px
          //margin: 10px 0
          .legend
            display: flex
            justify-content: center
            margin: auto
            &-line
              display: flex
              flex-direction: row
              align-items: center
              justify-content: flex-start
              margin: 0 0 0 10px
              &-img
                width: 40px
                height: 3px
              &-text
                p
                  font-size: 0.8em
                  font-weight: 600
                  padding: 0 10px
            .failure
              background: #f491ab
            .success
              background: #78bf88
          .total
            border: 1px solid #74cae7
            border-radius: 5px
            background: #fff
            display: flex
            align-items: center
            justify-content: center
            width: 200px
            margin: auto
            p
              color: #74cae7
      .right
        width: calc(100% - 400px)
        .top
          display: flex
          justify-content: flex-start
          padding: 0 35px
          height: 50px
          margin: 0 0 20px 0
          .btn-group
            margin: 0 15px 0 0
        .box
          margin: 80px 0 0 0

.tooltip-block
  cursor: pointer
  .tooltip
    font-weight: 400
    width: 160px
    height: 59px
    padding: 8px
    font-size: 0.9em

  .tp-failure
    width: 200px
    left: -7px
    &:before
      left: 70px

  .tp-success
    width: 165px
    left: -60px
    &:before
      left: 120px

//@media(max-width: 949px)
//  .statistics-box
//    &__field
//      display: flex
//      flex-direction: column
//      .right, .left
//        width: 100%
//      .left
//        .box
//          margin: 0 auto
//.right
//  .box
//    position: relative

</style>